import { fetchHistoryList, fetchHistoryRunRecords } from '@/api/modules/calculatorApi';
import { normalizeModuleId } from '@/utils/adaptiveRtModule';
import { createCourseOpenIntent } from '@/utils/openIntent';

function findLatestHistoryRow(results, modeId) {
  const rows = Array.isArray(results) ? results : [];
  if (!rows.length) return null;
  const target = normalizeModuleId(modeId);
  if (!target) return rows[0];
  const match = rows.find((row) => normalizeModuleId(row?.mode) === target);
  return match || rows[0];
}

function resolvePlanIdFromRow(row, runRecords, fallbackPlanId) {
  const direct = (fallbackPlanId || row?.plan_id || '').trim();
  if (direct) return direct;
  const items = row?.items || [];
  const fromItem = items.map((item) => item?.plan_id).find((id) => id);
  if (fromItem) return fromItem;
  for (const rec of runRecords || []) {
    const id = (rec?.plan_id || '').trim();
    if (id) return id;
  }
  return null;
}

/**
 * @param {object} params
 * @returns {object|null}
 */
export function buildCourseWorkspaceRestorePayload({
  courseId,
  modeId,
  planId,
  row,
  runData,
}) {
  if (!row?.run_id || !modeId) return null;
  const runRecords = runData?.records || [];
  const resolvedPlanId = resolvePlanIdFromRow(row, runRecords, planId);
  return {
    mode: modeId,
    plan_id: resolvedPlanId,
    openMode: null,
    run_id: null,
    runRecords,
    openIntent: createCourseOpenIntent({
      calculationModuleId: modeId,
      courseId: courseId ?? row.course_id ?? null,
      planId: resolvedPlanId,
    }),
  };
}

/**
 * Последний прогон истории курса для восстановления TCP/NTCP в рабочем модуле курса.
 */
export async function loadCourseWorkspaceRestore({ courseId, modeId, planId = null }) {
  if (!courseId || !modeId) return null;
  try {
    const data = await fetchHistoryList({ course_id: courseId });
    const row = findLatestHistoryRow(data?.results || [], modeId);
    if (!row?.run_id) return null;
    const runData = await fetchHistoryRunRecords(row.run_id);
    return buildCourseWorkspaceRestorePayload({
      courseId,
      modeId,
      planId,
      row,
      runData,
    });
  } catch {
    return null;
  }
}
